import angular from 'angular';

import EventService from './event.service';
import TransferService from './transfer.service';
import BalanceUpdateService from './balance-update.service';

export default angular
    .module('application.service.calendar.transaction', [])
    .service('eventService', EventService)
    .service('transferService', TransferService)
    .service('balanceUpdateService', BalanceUpdateService);



// WEBPACK FOOTER //
// ./src/application/service/calendar/transaction/index.js